import { Edit, ShowButton, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";

const EditClinic = () => {
  return (
    <Edit
      title="Редактиране на клиника"
      mutationMode="pessimistic"
      actions={
        <BackButtonToolbar
          additionalButton={
            <SecuredComponent permission={permissions.canPreviewClinics}>
              <ShowButton
                variant="contained"
                size="medium"
              />
            </SecuredComponent>
          }
        />
      }
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};
export default EditClinic;
